var render = function () {
  var _vm$height, _vm$card;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.callback ? 'button' : 'div', _vm._b({
    tag: "component",
    class: ['flippable-card', {
      flipping: _vm.isFlipped,
      'pure-button': !!_vm.callback
    }],
    style: {
      height: (_vm$height = _vm.height) !== null && _vm$height !== void 0 ? _vm$height : '100%'
    },
    attrs: {
      "name": (((_vm$card = _vm.card) === null || _vm$card === void 0 ? void 0 : _vm$card.cardText) + " card"),
      "tabindex": _vm.isTyping ? -1 : 0
    },
    on: {
      "click": _vm.onCardClick
    }
  }, 'component', _vm.$attrs, false), [_c('div', {
    staticClass: "card-front"
  }, [_vm._t("card-front")], 2), _c('div', {
    staticClass: "card-back"
  }, [_vm._t("card-back")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }